import axios from 'axios';
import { useRouter } from 'next/navigation';
import { useCallback } from 'react';

import { GoogleLoginSuccessCallback } from '../../../components/google-login/useGoogleLoginIFrameEventListener';
import { LoginErrorType, useLoginForm } from './LoginFormContext';
import { GoogleLoginBody, LoginResponse } from './LoginSchemas';

export function useGoogleSignInCallback(redirectAfterLogin?: string): GoogleLoginSuccessCallback {
    const router = useRouter();
    const { setLoginErrorType } = useLoginForm();

    return useCallback<GoogleLoginSuccessCallback>(
        (response) => {
            // Google one-tap already carries Google's own risk signal, so Google login sends no
            // reCAPTCHA token.
            axios
                .post<LoginResponse>('/api/login', {
                    googleCredential: response.credential,
                    agreementCheckbox: true,
                    redirectAfterLogin,
                } satisfies GoogleLoginBody)
                .then((result) => {
                    if (result.data.success) {
                        const redirectTo = result.data.redirectTo ?? '/';
                        if (redirectTo.startsWith('http')) {
                            window.location.href = redirectTo;
                        } else {
                            router.push(redirectTo);
                        }
                    } else if (result.data.reason === 'googleUserNotFound') {
                        const signUpParams = new URLSearchParams();
                        if (redirectAfterLogin) {
                            const redirectPath = redirectAfterLogin.startsWith('/')
                                ? redirectAfterLogin.substring(1)
                                : redirectAfterLogin;
                            signUpParams.set('redirectAfterRegister', redirectPath);
                        }
                        const query = signUpParams.toString();
                        router.push(`/sign-up${query ? `?${query}` : ''}`);
                    } else {
                        setLoginErrorType(LoginErrorType.INVALID_CREDENTIALS);
                    }
                })
                .catch(() => setLoginErrorType(LoginErrorType.INVALID_CREDENTIALS));
        },
        [router, setLoginErrorType, redirectAfterLogin],
    );
}
